import { get, isObject, isNull } from 'lodash';
import { formatUSD } from '@sparefoot/react-core/utils/format';

export default function buildStorageStats(pricesObject) {
	const formattedPrices = [];

	if (isObject(pricesObject)) {
		['5x5', '5x10', '10x10', '10x15', '10x20'].forEach((size) => {
			const price = get(pricesObject, `${size}.price`, null);
			if (!isNull(price)) {
				formattedPrices.push({ price: formatUSD(price), size });
			}
		});
	}

	return formattedPrices;
}
